import React, { createContext, useContext } from 'react'
import { createPortal } from 'react-dom'

export const MemberHeaderActionsTargetContext = createContext<HTMLDivElement | null>(null)

const MemberHeaderActions: React.FC = props => {
    const target = useContext(MemberHeaderActionsTargetContext)

    if (!target) return null

    return createPortal(<div className="member-manage__toolbar">{props.children}</div>, target)
}

export default MemberHeaderActions
